import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a61c045"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { "data-test": "about-title" }
const _hoisted_3 = {
  class: "about__contetn",
  "data-test": "about-content"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Breathing Time", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.wimhofmethod.com/",
  target: "_blank",
  title: "Open oficial \"Wim Hof Method\" website"
}, "Wim Hof Method", -1))
const _hoisted_7 = {
  class: "about__app_version",
  "data-test": "about-version"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("about.title")), 1),
    _createElementVNode("article", _hoisted_3, [
      _createVNode(_component_i18n_t, {
        keypath: "about.text",
        tag: "p",
        for: "title"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_router_link, { to: { name: 'BreathingExercisePreferences' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("about.preferences")), 1)
            ]),
            _: 1
          }),
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("about.app_version", [_ctx.version])), 1)
  ]))
}